import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";

import {
  Carousel,
  CarouselItem,
  CarouselItems,
  CarouselNext,
  CarouselPrev,
  Modal,
  ModalContainer,
  ModalHeader,
  Typography,
} from "@aviary/components";
import { ProductImage } from "@aviary/molecules/ProductImage/ProductImage";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ProductImageGalleryModal.styles";

interface Props {
  /**
   * Determines if the modal is open or not
   */
  isOpen: boolean;
  /**
   * Callback to close the modal
   */
  onClose: () => void;
  /**
   * An array of images to display in the carousel modal
   */
  images: string[];
  /**
   * The name of the product
   */
  name: string;
  /**
   * The index of the active image, will be the first image in the carousel
   */
  activeImageIndex: number;
  /**
   * Callback to set the active image index. OnChange for the carousel
   */
  setActiveImageIndex: (index: number) => void;
}

const ProductImageGalleryModal = ({
  isOpen,
  images,
  onClose,
  name,
  activeImageIndex,
  setActiveImageIndex,
}: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} overrideStyles={styles.modal}>
      <ModalContainer>
        {images.length > 1 && (
          <ModalHeader>
            <Typography>
              {activeImageIndex + 1}/{images.length}
            </Typography>
          </ModalHeader>
        )}

        {images.length === 1 && (
          <div css={styles.img}>
            <ProductImage name={name} image={images[0]} size="xxlarge" />
          </div>
        )}

        {images.length > 1 && (
          <Carousel
            onChange={index => setActiveImageIndex(index)}
            initialIndex={activeImageIndex}
            loop
            css={styles.carousel}
          >
            <CarouselItems>
              {images.map((slide, index) => (
                <CarouselItem key={index} css={styles.carouselItem}>
                  <div css={styles.img}>
                    <ProductImage name={name} image={slide} size="xxlarge" />
                  </div>
                </CarouselItem>
              ))}
            </CarouselItems>
            <div css={styles.carouselArrows}>
              <CarouselPrev size="small">
                <FontAwesomeIcon icon={faAngleLeft} />
              </CarouselPrev>
              <CarouselNext size="small">
                <FontAwesomeIcon icon={faAngleRight} />
              </CarouselNext>
            </div>
          </Carousel>
        )}
      </ModalContainer>
    </Modal>
  );
};

export { ProductImageGalleryModal };
